import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { GYPSUM, OLAF, KOALA } from 'HubStyleTokens/colors';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import ProductCatalogTableTitle from './ProductCatalogTableTitle';
const TableRow = styled.tr.withConfig({
  displayName: "ProductCatalogTableRow__TableRow",
  componentId: "bjs135-0"
})([":nth-child(even){background-color:", ";}:nth-child(odd){background-color:", ";}:hover{background-color:", " !important;}"], OLAF, GYPSUM, KOALA);
const LeftHeaderCell = styled.th.withConfig({
  displayName: "ProductCatalogTableRow__LeftHeaderCell",
  componentId: "bjs135-1"
})(["height:40px;& > p{margin-bottom:0;font-weight:500;}text-align:center;width:18.75%;min-width:175px;:nth-child(2){width:25%;text-align:left;}"]);
const UserIconCell = styled.th.withConfig({
  displayName: "ProductCatalogTableRow__UserIconCell",
  componentId: "bjs135-2"
})(["height:40px;width:2%;min-width:30px;& > p{margin-left:10px;margin-bottom:0;}"]);

const UserIcon = (freeUserAccess, showTooltip) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !showTooltip,
      placement: "right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricing-pages.freeUser.${freeUserAccess}`
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        name: "contacts"
      })
    })
  });
};

const ProductCatalogTableRow = ({
  featureId,
  children,
  productLine,
  freeUserAccess,
  showTooltip = true
}) => {
  return /*#__PURE__*/_jsxs(TableRow, {
    children: [/*#__PURE__*/_jsx(UserIconCell, {
      children: freeUserAccess && UserIcon(freeUserAccess, showTooltip)
    }), /*#__PURE__*/_jsx(LeftHeaderCell, {
      children: /*#__PURE__*/_jsx(ProductCatalogTableTitle, {
        featureId: featureId,
        productLine: productLine,
        showTooltip: showTooltip
      })
    }), children]
  }, featureId);
};

ProductCatalogTableRow.propTypes = {
  featureId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  productLine: PropTypes.oneOf(Object.values(ProductLines)).isRequired,
  freeUserAccess: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  showTooltip: PropTypes.bool
};
export default ProductCatalogTableRow;